import axios from 'axios';
import { API_URL } from '../utils/apiConfig';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

export const getInbox = async (params = {}) => {
  const res = await axios.get(`${API_URL}/communications/inbox`, {
    headers: authHeaders(),
    params,
  });
  return res.data;
};

export const getCommunicationStats = async () => {
  const res = await axios.get(`${API_URL}/communications/stats`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const getTemplates = async () => {
  const res = await axios.get(`${API_URL}/communications/templates`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const createTemplate = async (payload) => {
  const res = await axios.post(`${API_URL}/communications/templates`, payload, {
    headers: authHeaders(),
  });
  return res.data;
};

export const getAutomationRules = async () => {
  const res = await axios.get(`${API_URL}/communications/automation-rules`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const createAutomationRule = async (payload) => {
  const res = await axios.post(`${API_URL}/communications/automation-rules`, payload, {
    headers: authHeaders(),
  });
  return res.data;
};
